import { useT } from "@/lib/translation";

// Rendered by the root ErrorBoundary in main.tsx. All imports there are evaluated (App.tsx
// initialises i18n) before anything renders, so useT is safe even in a crash.
const RootFallback = () => {
  const t = useT();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-4 text-center p-8">
      <h2 className="text-xl font-semibold">
        {t("common:rootFallback.title")}
      </h2>
      <p className="text-muted-foreground max-w-sm">
        {t("common:rootFallback.body")}
      </p>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors"
      >
        {t("common:actions.reloadPage")}
      </button>
    </div>
  );
};

export default RootFallback;
